<template>
  <div class="banner-outer">
    <div class="container banner">
      <div class="banner-bg" :style="bgStyle"></div>
      <div class="banner-mask"></div>
      <div class="banner-title">
        <h2 class="title-main">{{ title }}</h2>
        <p v-if="subtitle" class="title-sub">{{ subtitle }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Banner",
  props: {
    title: {
      type: String,
      default: ""
    },
    subtitle: {
      type: String,
      default: ""
    },
    img: {
      type: String,
      default: ""
    }
  },
  computed: {
    bgStyle() {
      return {
        backgroundImage: "url(" + require("../assets/img/bgtop.png") + ")"
      };
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/variables.scss";

.banner-outer {
  padding-top: 28px;
}

.banner {
  height: 220px;
  position: relative;
  overflow: hidden;
  background: #1565c0;          // 与导航同色,色系顺滑过渡
}

.banner-bg {
  position: absolute;
  inset: 0;
  background-position: center;
  background-size: cover;
}

.banner-mask {
  position: absolute;
  inset: 0;
  background: rgba(10, 37, 64, 0.35);  // 蒙层降到 0.35,底图清晰可辨,白字仍清晰
}

.banner-title {
  position: absolute;
  inset: 0;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
  text-align: center;
  padding: 0 16px;
}

.title-main {
  margin: 0;
  font-size: $font-size-banner;
  font-weight: 500;
  letter-spacing: 3px;
  color: #fff;
}

.title-sub {
  margin: 10px 0 0;
  font-size: 12px;
  letter-spacing: 2px;
  color: rgba(255, 255, 255, 0.78);
}

@media (max-width: 960px) {
  .banner { height: 180px; }
  .title-main { font-size: 24px; letter-spacing: 2px; }
}

@media (max-width: 640px) {
  .banner { height: 150px; }
  .title-main { font-size: 20px; }
  .title-sub { font-size: 11px; }
}
</style>
